export const ENDPOINTS = {
  savedSearches: 'saved-searches',
  savedSearch: 'saved-searches/:id',

  // Share saved search endpoints
  shareSavedSearch: 'saved-searches/:id/share/:userId',
  usersWithAccess: 'saved-searches/:id/shared-users'
};
